import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BackgroundService {
    private worker: Worker | undefined;
    private workerMessages = new Subject<string>();

    constructor() {}

    startBackgroundService(): Observable<string> {
        // Check if Web Workers are supported
        if (typeof Worker !== 'undefined') {
            // Initialize the Web Worker
            this.worker = new Worker(new URL('../background.worker', import.meta.url), {
                type: 'module',
            });

            // Listen for messages from the worker
            this.worker.onmessage = ({ data }) => {
                this.workerMessages.next(data);
            };

            // Handle worker errors
            this.worker.onerror = (error) => {
                console.error('Worker error:', error);
                this.workerMessages.error(error);
            };

            // Start the worker by sending an initial message (optional)
            this.worker.postMessage('start');

            return this.workerMessages.asObservable();
        } else {
            // Web Workers not supported
            console.warn('Web Workers are not supported in this environment.');
            return new Observable<string>((observer) => {
                observer.error('Web Workers not supported');
            });
        }
    }

    // Method to stop the worker
    stopBackgroundService(): void {
        if (this.worker) {
            this.worker.terminate();
            this.worker = undefined;
        }
    }
}
